module.exports = __webpack_public_path__ + "assets/img/contact-us2.d706536b.jpg";